import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { COLOR_PRIMARY } from '../../constants';

const LoadingIndicator: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <CircularProgress size={60} thickness={4} sx={{ color: COLOR_PRIMARY }} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        Ładowanie...
      </Typography>
    </Box>
  );
};

export default LoadingIndicator; 